import { render, staticRenderFns } from "./CoordinationHub.vue?vue&type=template&id=cafda04e&"
import script from "./CoordinationHub.vue?vue&type=script&lang=js&"
export * from "./CoordinationHub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports